import { render } from "./DeclencheurScrollPage.vue?vue&type=template&id=5aa27380"
import script from "./DeclencheurScrollPage.vue?vue&type=script&lang=ts"
export * from "./DeclencheurScrollPage.vue?vue&type=script&lang=ts"
script.render = render

export default script